<template>
	<el-dialog title="修改通讯录" :visible.sync="visible" width="480px" show-close close-on-click-modal append-to-body
	 :before-close="handleClose">
		<el-form ref="iptDatas" :model="iptDatas" label-width="80px">
			<el-form-item v-for='(item,key) in iptDatas' :label="titles[key]" :key="key">
				<el-input :disabled="!isDisable[key]" v-model="iptDatas[key]" style='width: 290px;'></el-input>
			</el-form-item>
			<el-form-item >
				<el-button style='margin-left: 50px;' @click="visible = false">取 消</el-button>
				<el-button type="primary" @click="alter">确 定</el-button>
			</el-form-item>
		</el-form>
		<!-- <div class="flex-hen " v-for="(item,key) in iptDatas" :key="key">
			<span class="label-width">{{titles[key]}}：</span>
			<el-input :disabled="!isDisable[key]" v-model=""></el-input>
		</div> -->
		
	</el-dialog>
</template>

<script>
	import {
		EditPersonnelPhone
	} from '@/js/urls'
	export default {
		data() {
			return {
				visible: this.ishow,
				iptDatas: {},
				isDisable: {
					dept_id: false,
					dept_name: false,
					email: true,
					emp_id: false,
					emp_name: false,
					phone_number: true,
					seat_phone: true,
				},
				titles: {
					dept_name: '部门',
					email: '邮箱',
					emp_name: '姓名',
					phone_number: '手机',
					seat_phone: '座机',
				}
			};
		},
		props: {
			ishow: {
				type: Boolean,
				default: false
			},
			tanData: {
				type: Object,
				default: () => ({})
			}
		},
		computed: {
			wai_show() {
				return this.ishow
			},
			nei_show() {
				return this.visible
			}
		},
		created() {
			this.iptDatas = this.getDatas(this.tanData)
		},
		watch: {
			wai_show(a, b) {
				this.visible = a
			},
			nei_show(a, b) {
				this.$emit('update:ishow', a)
			}
		},
		methods: {
			getDatas(dd) {
				let obj = window.Shendufuzhi(dd)
				delete obj['dept_id']
				delete obj['emp_id']
				return obj
			},
			handleClose() {
				this.visible = false
			},
			alter() {
				let obj = window.Shendufuzhi(this.iptDatas)
				let MobileRegex = /^1[0-9]{10}$/
				let Email = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
				let Seatphone = /^(\d{3}-)(\d{7,8})$|^(\d{4}-)(\d{7})$|^(\d{4}-)(\d{7,8})$/
				obj['dept_id'] = this.tanData['dept_id']
				obj['emp_id'] = this.tanData['emp_id']

				if (this.iptDatas.phone_number == '') {
					this.$message.error('电话号码不能为空');
				} else if (!MobileRegex.test(this.iptDatas.phone_number)) {
					this.$message.error('手机号码格式不正确！')
				} else if (!Email.test(this.iptDatas.email) && this.iptDatas.email != '') {
					this.$message.error('邮箱格式不正确！')
				} else if (this.iptDatas.email.length >= 80) {
					this.$message.error('邮箱过长！')
				} else if (!Seatphone.test(this.iptDatas.seat_phone) && this.iptDatas.seat_phone != '') {
					this.$message.error('座机不正确！')
				} else {
					this.httpBack(EditPersonnelPhone(obj), (res) => {}, false, {
						successMsg: '修改成功！',
						errorMsg: '修改失败',
					})
					this.visible = false
					this.$emit('edit')
				}

			},
		}
	};
</script>
<style lang="scss">
	.label-width {
		width: 50px;
	}
</style>



// WEBPACK FOOTER //
// src/components/tan/tanEditComAddress.vue